import { InlineCode } from '@fuegokit/gatsby-theme-fuegodocs/src/components/Code';
import * as React from 'react';
export default {
  InlineCode,
  React
};